import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { authenticatedHeadersHash } from "views_shared/app/javascript/scripts/authentication";
import ImageCropped from "views_shared/app/javascript/components/ImageCropped";

function PublicPitchResult({ gid, setResultTitle, setResultUrl, setHidden }) {
  const match = gid.match(/gid:\/\/qwoted\/([^/]+)\/(\d+)/);
  const publicPitchId = match ? match[2] : null;
  const [publicPitch, setPublicPitch] = useState(null);

  useEffect(() => {
    const query = `${globalThis.Qwoted.SUPABASE_API_EXTERNAL_URL}/rest/v1/public_pitches?id=eq.${publicPitchId}`;
    fetch(query, {
      method: "GET",
      headers: new Headers(authenticatedHeadersHash()),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson[0]) {
          const pp = responseJson[0];
          setPublicPitch(pp);
          setResultTitle(pp.title);
          setResultUrl(`/public_pitches/${pp.id}`);
        }
      });
  }, [publicPitchId, setResultTitle, setResultUrl]);

  useEffect(() => {
    if (!publicPitch) {
      setHidden(true);
    } else {
      setHidden(false);
    }
  }, [publicPitch, setHidden]);

  if (!publicPitch) return null;

  return (
    <>
      <div className="d-flex">
        <ImageCropped
          wrapperClasses="me-2"
          src={publicPitch.profile_image_url}
          alt={publicPitch.profile_name}
          size={45}
        />
        <div className="d-flex flex-column lh-sm">
          <a href={`/profiles/${publicPitch.profile_slug}`}>{publicPitch.profile_name}</a>
          <div className="text-secondary">{publicPitch.profile_title_at_workplace}</div>
        </div>
      </div>
      {publicPitch.request_slug && (
        <div className="mt-2">
          <span className="text-muted">In response to: </span>
          <a href={`/requests/${publicPitch.request_slug}`}>{publicPitch.request_title}</a>
        </div>
      )}
      <span className="badge rounded-pill text-bg-secondary">Public Pitch</span>
    </>
  );
}

PublicPitchResult.propTypes = {
  gid: PropTypes.string.isRequired,
  setResultTitle: PropTypes.func.isRequired,
  setResultUrl: PropTypes.func.isRequired,
  setHidden: PropTypes.func.isRequired,
};

export default PublicPitchResult;
